export const userType = {
    1: 'employee',
    2: 'visitor',
    3: 'contractor_in_charge',
    4: 'contractors_employee',
    5: 'supplier_in_charge',
    6: 'supplier_employee',
    7: 'resident',
    8: 'guard',
    100: 'unknown',
};
export const USER_TYPE_MODEL = {
    EMPLOYEE: 1,
    VISITOR: 2,
    CONTRACTOR_IN_CHARGE: 3,
    CONTRACTORS_EMPLOYEE: 4,
    SUPPLIER_IN_CHARGE: 5,
    SUPPLIER_EMPLOYEE: 6,
    RESIDENT: 7,
    GUARD: 8,
    UNKNOWN: 100,
}
export const USER_TYPE_NAME_MODEL = {
    NONE:"NONE",
    EMPLOYEE: 'EMPLOYEE',
    VISITOR: 'VISITOR',
    CONTRACTOR_IN_CHARGE: 'CONTRACTOR_IN_CHARGE',
    CONTRACTORS_EMPLOYEE: 'CONTRACTORS_EMPLOYEE',
    CONTRACTOR:'CONTRACTOR',
    SUPPLIER_IN_CHARGE: 'SUPPLIER_IN_CHARGE',
    SUPPLIER_EMPLOYEE: 'SUPPLIER_EMPLOYEE',
    PROVIDER:"PROVIDER",
    RESIDENT: 'RESIDENT',
    GUARD: 'GUARD',
    UNKNOWN: 'UNKNOWN'
}

export const USER_ACCESS_KEY_MODEL = {
    CONTRACTORS:"contractors",
    CONTRACTOR:"contractor",
    SUPPLIERS:"suppliers",
    SUPPLIER:"supplier",
    CONTRACTS:"contracts",
    EMPLOYEE:"employee",
    CONTRACTOR_EMPLOYEE:"contractorEmployee",
    SUPPLIER_EMPLOYEE:"supplierEmployee",
    CONTRACTOR_VEHICLE:"contractorVehicle",
    SUPPLIER_VEHICLE:"supplierVehicle",
    EMPLOYEE_VEHICLE:"employeeVehicle"
}

export const USER_TYPE_DOCUMENT = {
    EMPLOYEE_DOCUMENT: 'employee_document',
    CONTRACTOR_DOCUMENT: 'contractor_document',
    CONTRACTOR_VEHICLE_DOCUMENT:"contractor_vehicle_document",
    SUPPLIER_DOCUMENT: 'supplier_document',
    SUPPLIER_VEHICLE_DOCUMENT:"supplier_vehicle_document"

};

export const ROLE_NAME_DEFAULT_MODEL = {
    ROLE_NONE : 'NONE',
    ROLE_ROOT : 'ROOT',
}

/**
 * Translation key of every user type name the catalog returns.
 */
export const USER_TYPE_NAME_TRANS = {
    [USER_TYPE_NAME_MODEL.NONE]: 'none',
    [USER_TYPE_NAME_MODEL.EMPLOYEE]: 'employee',
    [USER_TYPE_NAME_MODEL.VISITOR]: 'visitor',
    [USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE]: 'contractor_in_charge',
    [USER_TYPE_NAME_MODEL.CONTRACTORS_EMPLOYEE]: 'contractors_employee',
    [USER_TYPE_NAME_MODEL.CONTRACTOR]: 'contractor',
    [USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE]: 'supplier_in_charge',
    [USER_TYPE_NAME_MODEL.SUPPLIER_EMPLOYEE]: 'supplier_employee',
    [USER_TYPE_NAME_MODEL.PROVIDER]: 'supplier',
    [USER_TYPE_NAME_MODEL.RESIDENT]: 'resident',
    [USER_TYPE_NAME_MODEL.GUARD]: 'guard',
    [USER_TYPE_NAME_MODEL.UNKNOWN]: 'unknown',
};

/**
 * Name of a user type as it has to be painted. The catalog returns it in upper
 * case (SUPPLIER_EMPLOYEE), the known types are translated and any other name
 * is kept as the catalog returns it.
 *
 * @param {Function} translate - Localization function.
 * @param {string} [name] - Name of the user type as the catalog returns it.
 * @returns {string} Translated name of the type, an empty string when there is none.
 */
export const getUserTypeName = (translate, name) => {
    if (!name) return '';

    const key = USER_TYPE_NAME_TRANS[String(name).trim().toUpperCase().replace(/\s+/g, '_')];

    return key ? translate(key) : name;
};
